// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lineHover[data-v-14a4732d]{--tw-bg-opacity:1;background-color:rgb(173 173 173 / var(--tw-bg-opacity))}.red .lineHover[data-v-14a4732d]{--tw-bg-opacity:1;background-color:rgb(255 155 155 / var(--tw-bg-opacity))}.dark .lineHover[data-v-14a4732d]{--tw-bg-opacity:1;background-color:rgb(173 173 173 / var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
